module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6r8n7n-a6bc921c05c96c7c3d44b8602fa69b63.svg";